import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "site-content" }
const _hoisted_2 = { class: "section-content" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("img", {
    src: "/img/corporate_top.png",
    class: "mx-auto d-block",
    alt: "A group of people working together"
  })
], -1)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-9" }
const _hoisted_7 = {
  key: 0,
  class: "col-md-3"
}
const _hoisted_8 = {
  key: 1,
  class: "col-md-3 ml-md-auto mr-md-auto text-center"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("a", {
  href: "mailto:info@project-escape.co.uk?subject=Corporate+Enquiry",
  class: "btn btn-primary btn-lg mt-3"
}, "Enquire Now @ M'bro", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("a", {
  href: "mailto:hexham@project-escape.co.uk?subject=Corporate+Enquiry",
  class: "btn btn-primary btn-lg mt-3"
}, "Enquire Now @ Hexham", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_header = _resolveComponent("page-header")
  const _component_banner = _resolveComponent("banner")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_page_header, {
      image: "rusted-door",
      title: "Corporate Days"
    }),
    _createVNode("main", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _hoisted_4,
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sections, (section) => {
            return (_openBlock(), _createBlock("div", {
              key: section.section1Header,
              class: "mt-3"
            }, [
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _createVNode("h2", null, _toDisplayString(section.section1Header), 1),
                  _createVNode("div", {
                    innerHTML: section.section1Text
                  }, null, 8, ["innerHTML"])
                ]),
                (section.section1Image)
                  ? (_openBlock(), _createBlock("div", _hoisted_7, [
                      _createVNode("img", {
                        src: section.section1Image.file.url,
                        alt: section.section1ImageDesc,
                        class: "rounded mx-auto d-block"
                      }, null, 8, ["src", "alt"])
                    ]))
                  : _createCommentVNode("", true),
                (!section.section1Image)
                  ? (_openBlock(), _createBlock("div", _hoisted_8, [
                      _hoisted_9,
                      _hoisted_10
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_11
            ]))
          }), 128)),
          _createVNode(_component_banner)
        ])
      ])
    ])
  ]))
}